import {disconnectAndClearState} from 'iqos-mw';

import storageService from '@/services/storage/storageService';
import {selectChargerCodentify} from '@/state/selectors/mw';
import {clearDeviceData, setDeviceCodentify, updateDeviceCodentify} from '@/state/slices/deviceSlice';
import {resetFwuState} from '@/state/slices/fwuSlice';
import {resetMwState} from '@/state/slices/mwSlice';
import {dispatch, getState} from '@/state/store';

const storeSelectedDeviceCodentify = (codentify, isUpdate) => {
    const connectedCodentifyId = selectChargerCodentify(getState());

    //if connected device then update selected codentify id without clear state
    if (connectedCodentifyId === codentify) {
        dispatch(updateDeviceCodentify(codentify));
    } else {
        dispatch(setDeviceCodentify(codentify));
    }

    storageService.setSelectedDeviceCodentifyToLocalStorage(codentify);
};

const clearDeviceState = () => {
    dispatch(clearDeviceData());
    dispatch(resetMwState());
    dispatch(resetFwuState());
    disconnectAndClearState();
};

export default {
    clearDeviceState,
    storeSelectedDeviceCodentify,
};
